import script from "./ExpertSerp.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpertSerp.vue?vue&type=script&setup=true&lang=js"

import "./ExpertSerp.vue?vue&type=style&index=0&id=fa08015e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa08015e"]])

export default __exports__